import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ModalHeaderWithActions from "pages/UI/ModalHeaderWithActions";

interface Props {
  show: boolean;
  onClose: () => void;
}

const PhotoInfo = (props: Props) => {
  const { show, onClose } = props;
  const { t } = useTranslation("parts");

  return (
    <Modal show={show} onHide={onClose} className="change-modal">
      <ModalHeaderWithActions
        title={t("contacts.photoRequirements.requirementsHeader")}
        onClose={onClose}
        canSubmit={false}
        isInEditMode={false}
        onSubmit={() => {}}
      />
      <Modal.Body>
        <div>
          <ul>
            <li>{t("contacts.photoRequirements.colorRequirement")}</li>
            <li>{t("contacts.photoRequirements.sizeRequirement")}</li>
            <li>{t("contacts.photoRequirements.noScanRequirement")}</li>
            <li>{t("contacts.photoRequirements.backgroundRequirement")}</li>
            <li>{t("contacts.photoRequirements.noHeadwearRequirement")}</li>
            <li>{t("contacts.photoRequirements.facingRequirement")}</li>
            <li>{t("contacts.photoRequirements.centerRequirement")}</li>
            <li>{t("contacts.photoRequirements.glassesRequirement")}</li>
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PhotoInfo;
